<script lang="ts">
import AppTextButton from '@/components/inputs/AppTextButton.vue'
import type { TIconValue } from '@/utils/helper-objects'
import { ThemeType } from '@goodlifeplus/themes'
import { type PropType, defineComponent } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  components: { AppTextButton },
  props: {
    icon: {
      type: String as PropType<TIconValue> | null,
    },
    title: {
      type: String,
      required: false,
    },
    viewAllRoute: {
      type: Object as PropType<RouteLocationRaw>,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    previousDisabled: {
      type: Boolean,
      default: false,
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
    titleClass: {
      type: String,
      default: '',
    },
  },
  emits: ['nextClick', 'previousClick'],
  computed: {
    isSubscription(): boolean {
      return this.$theme.type === ThemeType.Subscription
    },
  },
})
</script>

<template>
  <div
    class="flex flex-row items-center gap-2 carousel-header @sm/main:min-h-8 empty:hidden"
  >
    <AppIcon v-if="icon" size="sm" class="sm:h-8 sm:w-8" :icon></AppIcon>
    <h2
      v-if="title"
      class="flex-1 overflow-hidden text-ellipsis text-nowrap text-lg/8"
      :class="[
        isSubscription
          ? 'normal-case font-black sm:text-[32px] leading-[42px]'
          : 'uppercase font-bold sm:text-2xl/10',
        titleClass,
      ]"
    >
      {{ title }}
    </h2>
    <span
      v-if="showNavigation && (!nextDisabled || !previousDisabled)"
      class="flex flex-row gap-2"
      :class="{ 'ml-auto': !title && !icon }"
    >
      <button
        class="button button-new button-new--icon-only touch-manipulation bg-slate-200"
        :disabled="previousDisabled"
        title="Previous Page"
        @click="$emit('previousClick')"
      >
        <AppIcon icon="ArrowLeft" size="xs" class="sm:h-6 sm:w-6"></AppIcon>
      </button>
      <button
        class="button button-new button-new--icon-only -scale-x-100 touch-manipulation bg-slate-200"
        :disabled="nextDisabled"
        title="Next Page"
        @click="$emit('nextClick')"
      >
        <AppIcon icon="ArrowLeft" size="xs" class="sm:h-6 sm:w-6"></AppIcon>
      </button>
    </span>
    <slot name="view-all-route" :view-all-route="viewAllRoute">
      <AppTextButton
        v-if="viewAllRoute && isSubscription"
        :variant="UI.TextButton.Variant.Tertiary"
        :size="UI.TextButton.Size.Medium"
        :route="viewAllRoute"
        label="View All"
        :icon="Icons.ArrowRight"
        :icon-position="UI.TextButton.IconPosition.End"
      />
      <AppButton
        v-else-if="viewAllRoute"
        title="View all"
        class="button button-new leading-none view-all-button"
        :route="viewAllRoute"
      >
        View All
      </AppButton>
    </slot>
  </div>
</template>
